@if (data && data.length) {
  <ul [attr.aria-label]="'labels.tags' | translate">
    @for (label of data; track label) {
      @if (label.entityLabel || label.value || label) {
        <li
          [ngStyle]="!type && childStyles"
          >
          {{ (label.entityLabel || (label.value ? label.value : label)) | translate }}
        </li>
      }
    }
  </ul>
}
